import { transformCivilStatus } from 'shell/utils/consult-person/request-transformer/marital-status/civil-status';
import { Request5008, RequestRegistrationWidowhood } from 'shell/models/register-widowhood';
import { RegistrationWidowhoodFormVM } from 'mutation/view-models/registration-widowhood';
import { transformerRequestMarriageAnpr05Mutation } from './common-request-transformer';
import { transformDocumentDigital } from 'shell/utils/consult-person/request-transformer/shared/transform-document-digital';

export const transformerRequestRegistrationWidowhoodData = (
  values: RegistrationWidowhoodFormVM
): RequestRegistrationWidowhood => {
  const matrimonio = transformerRequestMarriageAnpr05Mutation(values.marriage);

  const statoCivile = transformCivilStatus(values.civilStatus);

  const isForeign = values.widowhood?.isForeign;

  const luogoEvento = {
    luogoEccezionale: values.widowhood?.exceptionalPlace || undefined,
    comune:
      isForeign || values.widowhood?.exceptionalPlace
        ? null
        : {
            nomeComune: values.widowhood?.municipality?.description || undefined,
            codiceIstat: values.widowhood?.municipality?.id || undefined,
            siglaProvinciaIstat: values.widowhood?.municipality?.province || undefined,
            descrizioneLocalita: values.widowhood?.locality || undefined,
          },
    localita:
      !isForeign || values.widowhood?.exceptionalPlace
        ? null
        : {
            descrizioneLocalita: values.widowhood?.foreignMunicipality?.description || undefined,
            descrizioneStato: values.widowhood?.foreignState?.value || undefined,
            codiceStato: values.widowhood?.foreignState?.id || undefined,
            provinciaContea: values.widowhood?.foreignProvince || undefined,
          },
  };

  // const attoEvento =
  //   values.widowhood?.office ||
  //   values.widowhood?.municipalityAct ||
  //   values.widowhood?.year ||
  //   values.widowhood?.portion ||
  //   values.widowhood?.range ||
  //   values.widowhood?.documentNumber ||
  //   values.widowhood?.documentDate
  //     ? {
  //         comuneRegistrazione: values.widowhood?.municipalityAct
  //           ? {
  //               nomeComune: values.widowhood?.municipalityAct?.description || undefined,
  //               codiceIstat: values.widowhood?.municipalityAct?.id || undefined,
  //               siglaProvinciaIstat: values.widowhood?.municipalityAct?.province || undefined,
  //             }
  //           : undefined,
  //         ufficioMunicipio: values.widowhood?.office || undefined,
  //         anno: values.widowhood?.year?.toFormat('yyyy') || undefined,
  //         parte: values.widowhood?.portion || undefined,
  //         serie: values.widowhood?.range || undefined,
  //         numeroAtto: values.widowhood?.documentNumber || undefined,
  //         volume: values.widowhood?.regVol || undefined,
  //         dataFormazioneAtto: values.widowhood?.documentDate?.toFormat('yyyy-MM-dd') || undefined,
  //         trascritto: values.widowhood?.isTranscribed ? '1' : '0',
  //       }
  //     : undefined;

  const withActPaper =
    values?.widowhood?.paper?.actYear ||
    values?.widowhood?.paper?.actPart ||
    values?.widowhood?.paper?.actSeries ||
    values?.widowhood?.paper?.actNumber ||
    values?.widowhood?.paper?.actVolume ||
    values?.widowhood?.paper?.actDate ||
    values?.widowhood?.paper?.actMunicipality?.description ||
    values?.widowhood?.paper?.actMunicipality?.id ||
    values?.widowhood?.paper?.actMunicipality?.province;

  const withActDigital = Boolean(values?.widowhood?.digital);

  const richiesta5008: Request5008 = {
    matrimonio,
    statoCivile,
    datiControllo: {
      gestioneCF: '3',
      tipoMutazione: ['01', '13'],
    },
    generalitaPerRicerca: {
      ...(values.person?.generality || {}),
    },
    generalitaDaModificare: {
      generalita: {
        ...(values.person?.generality || {}),
      },
    },
    testataRichiesta: {
      dataDecorrenza: values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd') || undefined,
    },
    vedovanza: {
      ordineMatrimonioPrecedente: values.widowhood?.number || '0',
      datiMorteconiuge: {
        dataEvento: values.widowhood?.eventDate?.toFormat('yyyy-MM-dd') || undefined,
        senzaGiorno:
          !values.widowhood?.eventChoiceDate?.includes('day') &&
          values.widowhood?.eventChoiceDate?.includes('month')
            ? '1'
            : undefined,
        senzaGiornoMese:
          !values.widowhood?.eventChoiceDate?.includes('day') &&
          !values.widowhood?.eventChoiceDate?.includes('month')
            ? '1'
            : undefined,
        luogoEvento,
        attoEventoANPR:
          withActDigital || withActPaper
            ? {
                atto: withActPaper
                  ? {
                      anno: values.widowhood?.paper?.actYear || undefined,
                      parte: values.widowhood?.paper?.actPart || undefined,
                      serie: values.widowhood?.paper?.actSeries || undefined,
                      numeroAtto: values.widowhood?.paper?.actNumber || undefined,
                      volume: values.widowhood?.paper?.actVolume || undefined,
                      dataFormazioneAtto:
                        values.widowhood?.paper?.actDate?.toFormat('yyyy-MM-dd') || undefined,
                      trascritto: values.widowhood?.paper?.transcribed ? '1' : undefined,
                      comuneRegistrazione: values.widowhood?.paper?.actMunicipality
                        ? {
                            nomeComune:
                              values.widowhood?.paper?.actMunicipality?.description || undefined,
                            codiceIstat: values.widowhood?.paper?.actMunicipality?.id || undefined,
                            siglaProvinciaIstat:
                              values.widowhood?.paper?.actMunicipality?.province || undefined,
                          }
                        : undefined,
                    }
                  : undefined,
                attoANSC: withActDigital
                  ? transformDocumentDigital(values?.widowhood?.digital || undefined)
                  : undefined,
              }
            : undefined,
      },
    },
  };

  return {
    richiesta5008,
    risposta3002: values.subjectData || undefined,
  };
};
